import { getData, postData } from "./apiUtils";
import * as CONFIG from '../utils/config';

export function getTemplateExampleModuleId(templateId) {
    return getData(CONFIG.GET_TEMPLATE_EXAMPLE_MODULE_ID() + templateId);
}

export function updateTemplateExample(templateId, moduleId, useAsExample) {
    return postData(CONFIG.UPDATE_TEMPLATE_EXAMPLE_URL(), { TemplateId: templateId, ModuleId: moduleId, SetAsExample: useAsExample });
}
